/* jshint esversion: 6 */
/* jshint esversion: 9 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import axios from 'axios';
import { useContext, useEffect, useRef, useState } from 'react';
import { IoIosArrowBack, IoIosArrowForward, IoIosCloseCircle } from 'react-icons/io';
import { Link, useNavigate } from 'react-router-dom';
import { MyContext } from '../../Context/MyProvider';
import { HiMiniMinusSmall } from 'react-icons/hi2';
import { LuChevronRight, LuPlus } from 'react-icons/lu';
import { showToast } from '../../showTost';
import { FiMapPin, FiPlus } from 'react-icons/fi';
import { IoCallOutline, IoChevronDown } from 'react-icons/io5';
import { TiLocation } from 'react-icons/ti';
import Payment from '../../Payment/Payment';
import { GoogleMap, Marker, useLoadScript } from '@react-google-maps/api';
import PhoneInput, { formatPhoneNumberIntl } from "react-phone-number-input";
import Wallet from "../../assets/Icon/wallet.svg";
import { useTranslation } from 'react-i18next';
import Loading from '../Loading';
import secureLocalStorage from "react-secure-storage";
export const DetailsList = ({ item, index, ImgBaseUrl, isShow, currency, detaillod, setDetailLod, Userid, Docid, productId, details, ApiBaseUrl, HandleFetchData, setDetails, setIsShow }) => {

  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);

  const handleAddToCart = (item) => {
    if (!Userid && detaillod) return;

    const payload = {
      uid: Userid,
      doctor_id: Docid,
      prod_id: productId,
      pro_price: item.price,
      pro_ptype: item.title,
      pro_qty: item.cart_qty,
      pro_qty_type: 1,
      mode: 1,
    };

    setDetailLod(true);
    setLoading(true);

    const updatedDetails = details.map(detail =>
      detail.title === item.title
        ? { ...detail, cart_qty: detail.cart_qty + 1 }
        : detail
    );

    axios.post(`${ApiBaseUrl}/customer/cart_detail`, payload)
      .then((response) => {
        // console.log(response);
        if (response.data.ResponseCode === 200) {
          HandleFetchData();
          setDetails(updatedDetails);
        }
        setDetailLod(false);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Failed to add item to cart:', error);
      });
  };


  const handleRemoveToCart = (item) => {
    if (!Userid && detaillod) return;

    const payload = {
      uid: Userid,
      doctor_id: Docid,
      prod_id: productId,
      pro_price: item.price,
      pro_ptype: item.title,
      pro_qty: item.cart_qty,
      pro_qty_type: 2,
      mode: 1,
    };

    setDetailLod(true);
    setLoading(true);


    const updatedDetails = details.map(detail =>
      detail.title === item.title
        ? { ...detail, cart_qty: detail.cart_qty - 1 }
        : detail
    );

    axios.post(`${ApiBaseUrl}/customer/cart_detail`, payload)
      .then((response) => {
        if (response.data.ResponseCode === 200) {
          HandleFetchData();
          setDetails(updatedDetails);
          if (item.cart_qty === 1) {
            setIsShow("");
          }
        }
        setDetailLod(false);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Failed to add item to cart:', error);
      });
  };

  return <div key={index} className="border-t-[1px] border-[#8080803b] py-[8px]">
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-[10px]">
        <img src={ImgBaseUrl + isShow.img} className='border-[1px] border-[#8080803b] rounded-[10px] w-[80px] h-[80px] object-cover' alt="" />
        <div className="leading-[22px]">
          <h1 className='font-[500] text-[17px]'>{isShow.name}</h1>
          <span className='text-gray-500'>{item.title}</span>
          <div className="flex items-center gap-[10px]">
            <h1 className='font-[500] text-[18px]'>{currency}{item.price}</h1>
            <span className='line-through text-gray-500'>{currency}{item.base_price}</span>
            <h1 className='bg-orange-400 text-white px-[10px] rounded-[50px] text-[14px] font-[500]'>{item.discount}% OFF</h1>
          </div>
        </div>
      </div>
      <div className='border-[1px] border-[#0d4047] text-[#0d4047] font-[500] text-[18px] rounded-[10px] py-[2px]'>
        {loading
          ? <div className="px-[25px] py-[2px]">
            <div className="loader2"></div>
          </div>
          : item.cart_qty
            ? <div className="flex items-center px-[5px] gap-[10px]">
              <button onClick={() => handleRemoveToCart(item)}><HiMiniMinusSmall /></button>
              <h1>{item.cart_qty}</h1>
              <button onClick={() => handleAddToCart(item)}><LuPlus /></button>
            </div>
            : <button onClick={() => handleAddToCart(item)} className='px-[20px]' >{t("Add")}</button>}
      </div>
    </div>
  </div>
}

const Checkout = () => {

  const { t } = useTranslation();

  const { ApiBaseUrl, ImgBaseUrl, isPayment, setIsPayment, paymentStatus, setPaymentStatus, mapKey, setActivePage, transactionid } = useContext(MyContext);
  const site_currency = secureLocalStorage.getItem("currency");
  const currency = site_currency ? site_currency : "$";

  const [productList, ProductList] = useState([]);
  const [details, setDetails] = useState();
  const [isShow, setIsShow] = useState();
  const [productId, setProductId] = useState();
  const [isPhotoAdd, setIsPhotoAdd] = useState(false);
  const [isDriverSelected, setIsDriverSelected] = useState(false);
  const [myWallet, setMyWallet] = useState();
  const [myWallet2, setMyWallet2] = useState();
  const [wallet, setWallet] = useState();
  const [photos, setPhotos] = useState([]);
  const [isCouponShow, setIsCouponShow] = useState(false);
  const [couponCode, setCouponCode] = useState();
  const [couponList, setCouponList] = useState([]);
  const [totalAmount, setTotalAmount] = useState();
  const [totalAmount2, setTotalAmount2] = useState();
  const [shopTotal, setShopTotal] = useState();
  const [isLocationShow, setIsLocationShow] = useState(false);
  const [isLocationShow2, setIsLocationShow2] = useState(false);
  const [addressList, setAddressList] = useState([]);
  const [selectAddress, setSelectAddress] = useState();
  const [comRate, setComRate] = useState();
  const [value, setValue] = useState();
  const [addressData, setAddressData] = useState({ address: "", houseno: "", mobile: "", landmark: "", instruction: "", address_as: "" });
  const [latitude, setLatitude] = useState();
  const [longitude, setLongitude] = useState();
  const [loading, setLoading] = useState(true);
  const [allData, setAllData] = useState();
  const [detaillod, setDetailLod] = useState(false);

  const LocalData = sessionStorage.getItem("Docdetails");
  if (LocalData) {
    var { Docid } = JSON.parse(LocalData);
  }
  const Userid = secureLocalStorage.getItem("Userid");

  const InputRef = useRef(null);
  const navigate = useNavigate();

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: mapKey
  });

  useEffect(() => {
    window.scrollTo(0, 0);

    navigator.geolocation.getCurrentPosition(position => {
      const lat = position.coords.latitude;
      const long = position.coords.longitude;
      setLatitude(lat);
      setLongitude(long);
    });

    HandleFetchData();
    HandleGetCouponList();
    HandleGetAddress();

  }, []);

  const HandleGetAddress = () => {
    if (Userid) {
      axios.post(`${ApiBaseUrl}/customer/address_list`, { id: Userid })
        .then((res) => {
          // console.log(res);
          setAddressList(res.data.address_list);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const HandleGetCouponList = () => {
    axios.post(`${ApiBaseUrl}/customer/coupon_list`, { doctor_id: Docid })
      .then((res) => {
        // console.log("coupon_list", res);
        setCouponList(res.data.coupon_list);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const HandleFetchData = () => {
    if (Userid) {
      axios.post(`${ApiBaseUrl}/customer/checkout_data`, { uid: Userid, doctor_id: Docid })
        .then((res) => {
          // console.log("checkout_data", res);
          if (res.data.ResponseCode === 200) {
            setLoading(false);
            setMyWallet(res.data.wallet_amount);
            setShopTotal(res.data.tot_price);
            ProductList(res.data.product_list);
            HandleGetCommission(res.data.com_data, res.data.tot_price);
            const hasPrescription = res.data.product_list.some(
              item => item.prescription_require === "Required"
            );
            setIsPhotoAdd(hasPrescription);
            if (res.data.product_list.length <= 0) {
              navigate("/store-home");
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const HandleGetCommission = (data, price) => {
    if (data.commisiion_type === "fix") {
      setComRate({ rate: data.commission_rate, type: data.commisiion_type });
    } else {
      const Rate = (price / data.commission_rate);
      setComRate({ rate: Rate.toFixed(0), type: (data.commission_rate + data.commisiion_type) });
    }
  };

  useEffect(() => {
    const TotalAmt = Number(comRate?.rate) + shopTotal;
    setTotalAmount2(TotalAmt);
    const CouponTotal = couponCode ? TotalAmt - couponCode.amt : TotalAmt;
    setTotalAmount(CouponTotal);
  }, [comRate, shopTotal, couponCode]);

  useEffect(() => {
    if (myWallet > totalAmount) {
      const CouponTotal = couponCode ? totalAmount2 - couponCode.amt : totalAmount2;
      setTotalAmount(isDriverSelected ? 0 : CouponTotal);
      setWallet(isDriverSelected ? CouponTotal : 0);
    } else {
      const Total = isDriverSelected ? totalAmount - myWallet : totalAmount2;
      setTotalAmount(Total);
    }

    if (myWallet < totalAmount) {
      setMyWallet2(isDriverSelected ? 0 : myWallet);
      setWallet(isDriverSelected ? myWallet : 0);
    } else {
      const MyTotal = isDriverSelected ? myWallet - totalAmount : myWallet;
      setMyWallet2(MyTotal);
    }

  }, [isDriverSelected]);

  const HandleDetails = (item) => {
    if (isDriverSelected) {
      setIsDriverSelected(!isDriverSelected);
    }
    setIsShow({ name: item.product_name, img: item.product_image });
    setDetails(item.price_detail);
    setProductId(item.id);
  };

  const HandleRemovePhoto = (index) => {
    const Copy = [...photos];
    Copy.splice(index, 1);
    setPhotos(Copy);
  };

  const HandleCoupanAdd = (code, amt, id) => {
    setCouponCode({ code, amt, id });
    showToast({ title: t("Coupon Add Successful"), id: "success" });
    setIsCouponShow(false);
  };

  const HandleCoupanRemove = () => {
    if (couponCode) {
      setCouponCode("");
    } else {
      setIsCouponShow(true);
    }
    if (isDriverSelected) {
      setIsDriverSelected(!isDriverSelected);
    }
  };

  const HandleContinuePayment = () => {
    if (isPhotoAdd && photos.length === 0) {
      showToast({ title: t("Add patient prescription"), id: "error" });
      return;
    }

    if (!selectAddress) {
      showToast({ title: t("Select deliver address"), id: "error" });
      return;
    }

    if (isDriverSelected && totalAmount === 0) {
      HandleBooking();
    } else {
      setIsPayment(true);
    }

    const WalletAmount = isDriverSelected && couponCode ? totalAmount2 - totalAmount - couponCode.amt : totalAmount2 - totalAmount;
    const TotalPrice = couponCode ? totalAmount2 - couponCode.amt : totalAmount2;

    const Data = {
      uid: Userid,
      doctor_id: Docid,
      tot_price: TotalPrice,
      coupon: couponCode ? couponCode.id : "",
      coupon_amount: couponCode ? couponCode.amt : 0,
      site_commission: comRate.rate,
      address: selectAddress.id,
      wallet_amount: WalletAmount ? WalletAmount : 0,
    };

    setAllData(Data);
    sessionStorage.setItem("page", "3");

  };

  useEffect(() => {
    if (!paymentStatus) return;
    if (paymentStatus === "PaymentDone") {
      HandleBooking();
      setPaymentStatus("");
      setIsPayment(false);
    }
  }, [paymentStatus]);


  const HandleBooking = () => {
    if (isPhotoAdd) {
      HandleAddPrescription();
    } else {
      HandleBookOrder();
    }
  };

  const HandleAddPrescription = () => {
    if (Userid) {

      const formData = new FormData();
      formData.append("uid", Userid);
      formData.append("doctor_id", Docid);

      photos.forEach((photo) => {
        formData.append("image", photo);
      });

      axios.post(`${ApiBaseUrl}/customer/add_patient_prescription`, formData)
        .then((res) => {
          // console.log("add_patient_prescription", res);
          if (res.data.ResponseCode === 200) {
            HandleBookOrder();
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };


  const HandleBookOrder = () => {
    const PaymentId = sessionStorage.getItem("Paymentid");

    if (Userid) {

      const WalletAmount = isDriverSelected && couponCode ? totalAmount2 - totalAmount - couponCode.amt : totalAmount2 - totalAmount;
      const TotalPrice = couponCode ? totalAmount2 - couponCode.amt : totalAmount2;

      const Data = {
        uid: Userid,
        doctor_id: Docid,
        tot_price: TotalPrice,
        coupon: couponCode ? couponCode.id : "",
        coupon_amount: couponCode ? couponCode.amt : 0,
        site_commission: comRate.rate,
        address: selectAddress.id,
        wallet_amount: WalletAmount ? WalletAmount : 0,
        payment_id: PaymentId ? PaymentId : '',
        transactionId: transactionid || "",
      };

      axios.post(`${ApiBaseUrl}/customer/add_product_order`, Data)
        .then((res) => {
          // console.log("add_product_order", res);
          if (res.data.ResponseCode === 200) {
            showToast({ title: res.data.message, id: "success" });
            navigate("/dashbord/order");
            setActivePage(2);
            sessionStorage.removeItem("Paymentid");
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const HandleSaveAddress = async () => {

    if (!addressData.address && !addressData.houseno && !addressData.landmark && !addressData.instruction && !addressData.address_as) {
      showToast({ title: t("Please Enter Details"), id: "error" });
      return;
    }

    if (!value) {
      showToast({ title: t("Please Enter Details"), id: "error" });
      return;
    }

    const Userid = secureLocalStorage.getItem("Userid");
    if (Userid) {
      const formattedNumber = formatPhoneNumberIntl(value);
      const countryCode = formattedNumber.split(' ')[0];
      const numberWithoutCode = formattedNumber.replace(countryCode, '').trim();
      const cleanedNumber = numberWithoutCode.split(' ').join('');

      const Data = {
        id: Userid,
        house_no: addressData.houseno,
        address: addressData.address,
        landmark: addressData.landmark,
        address_as: addressData.address_as,
        country_code: countryCode,
        phone: cleanedNumber,
        latitude: latitude,
        longitude: longitude,
        google_address: await HandleGetGoogleAddress(latitude, longitude),
        instruction: addressData.instruction
      };

      // console.log("Data", Data);

      axios.post(`${ApiBaseUrl}/customer/add_address`, Data)
        .then((res) => {
          if (res.data.ResponseCode === 200) {
            setIsLocationShow2("");
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const HandleGetGoogleAddress = async (lat, long) => {
    try {

      const response = await axios.get(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${long}&key=${mapKey}`
      );

      const address = response.data.results[0]?.formatted_address;
      // console.log('Address:', address);
      return address;
    } catch (error) {
      console.error('Error fetching address:', error);
    }
  };

  const handleMapClick = (event) => {
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();
    setLatitude(lat);
    setLongitude(lng);
  };

  useEffect(() => {
    loading
      ? document.body.style.overflow = "hidden"
      : document.body.style.overflow = "auto";
  }, [loading]);

  return (
    <div className='width-container pb-[50px] content-wrapper lab-details'>
      {loading
        ? <Loading CustomeStyle="fixed left-0 top-0 h-[100vh] w-full flex items-center justify-center bg-white" />
        :
        <div className="">
          <div className="flex items-center justify-between top-section">
            <Link to="/" className="flex items-center gap-[5px] border-[2px] border-gray-200 rounded-[50px] px-[10px] group py-[4px] hover:bg-black">
              <IoIosArrowBack className=' group-hover:text-white' />
              <h1 className='font-[500] group-hover:text-white'> {t("Go Home")}</h1>
            </Link>
            <div className="flex items-center gap-[10px]">
              <Link to="/store-home" className='font-[500] text-gray-700'>{t("Shop Home Page")}</Link>
              <IoIosArrowForward />
              <h1 className='font-[500] text-gray-400 pagename'>{t("Checkout")}</h1>
            </div>
          </div>

          <div className="book-section book-appointment">

            <div className="width-box">

              <div className="section-1">
                <h1 className='font-[500] text-[18px]'>{t("Order Details")}</h1>
                <div className="">
                  {productList.map((item, index) => {
                    const TotalCart = item.price_detail.reduce((acc, curr) => acc + curr.cart_qty, 0);
                    return <div key={index} className={`${index !== 0 && "border-t-[1px] "} border-[#8080803b] mb-[10px]`}>
                      <div className="flex items-end justify-between">
                        <div className="flex items-center gap-[10px]">
                          <img className='w-[70px] h-[70px] object-cover border-[1px] border-[#8080803b] rounded-[10px] mt-[10px]' src={ImgBaseUrl + item.product_image} alt="" />
                          <div className="leading-[19px]">
                            {item.prescription_require === "Required" && <span className='text-red-700 text-[14px] font-[500]'>{t("Prescription Required")}</span>}
                            <h1 className='font-[500] text-[18px]'>{item.product_name}</h1>
                            <span className='text-gray-500'>{item.pro_type}</span>
                            <div className="flex items-center gap-[10px]">
                              <h1 className='font-[500] text-[18px]'>{currency}{item.price_detail[0].price}</h1>
                              <span className='line-through text-gray-500'>{currency}{item.price_detail[0].base_price}</span>
                              <h1 className='bg-orange-400 text-white px-[10px] rounded-[50px] text-[14px] font-[500] py-[2px]'>{item.price_detail[0].discount}% OFF</h1>
                            </div>
                          </div>
                        </div>
                        <div className="text-center">
                          <button onClick={() => HandleDetails(item)} className='border-[1px] border-[#0d4047] text-[#0d4047] font-[500] text-[18px] rounded-[10px] py-[2px]'>
                            {TotalCart
                              ? <div className="flex items-center px-[5px] gap-[10px]">
                                <HiMiniMinusSmall />
                                <h1>{TotalCart}</h1>
                                <LuPlus />
                              </div>
                              : <h1 className='px-[20px]'>{t("Add")}</h1>}
                          </button>
                          <h1 className='text-[#0d4047]'>{item.price_detail.length} {t("Option")}</h1>
                        </div>
                      </div>
                    </div>
                  })}
                </div>
              </div>

              {isPhotoAdd && <div className="section-2">

                <div className="flex items-center justify-between">
                  <h1 className='font-[500] text-[18px]'>{t("Your Uploaded Prescription")}</h1>
                  {photos?.length >= 1 && (
                    <button
                      onClick={() => InputRef.current?.click()}
                      className='text-[#0d4047] font-[500] text-[16px]'
                    >
                      {t("+ Add More")}
                    </button>
                  )}
                </div>

                <div>
                  {photos?.length === 0 ? (
                    <div className="h-[100px] flex items-center justify-center">
                      <button
                        onClick={() => InputRef.current?.click()}
                        className="border-[1px] border-[#0d4047] border-dashed rounded-[15px]"
                      >
                        <h1 className='text-[#0d4047] font-[500] text-[16px] py-[10px] px-[20px]'>{t("+ Add Prescription")}</h1>
                      </button>
                    </div>
                  ) : (
                    <div className="pt-[10px] mt-[5px] flex items-center gap-[10px] scroll-container">
                      {photos?.map((item, index) => (
                        <div key={index} className="relative">
                          <img
                            src={URL.createObjectURL(item)}
                            className='min-w-[100px] min-h-[100px] max-w-[100px] max-h-[100px] object-cover rounded-[10px]'
                            alt=""
                          />
                          <button onClick={() => HandleRemovePhoto(index)} className="absolute -top-[5px] -right-[5px]">
                            <IoIosCloseCircle className='text-[25px] text-red-500' />
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <input
                  ref={InputRef}
                  onChange={(e) => {
                    if (e.target.files && e.target.files[0]) {
                      setPhotos([...photos, e.target.files[0]]);
                    }
                    e.target.value = null;
                  }}
                  accept="image/*"
                  type="file"
                  className='hidden'
                />

              </div>}

            </div>

            <div className="width-box">

              {myWallet !== 0 && <div style={{ margin: "0" }} className="section-5">
                <div className="flex items-center justify-between mb-[10px]">
                  <h1 className='title'>{t("Pay from Wallet")}</h1>
                  <label className="switch2">
                    <input type="checkbox" checked={isDriverSelected} onChange={() => setIsDriverSelected(!isDriverSelected)} />
                    <span className="slider round"></span>
                  </label>
                </div>
                <div className="border-[1px] border-[#8080803b] py-[10px] px-[5px] rounded-[10px] flex items-center justify-between">
                  <div className="flex items-center gap-[5px]">
                    <img src={Wallet} alt="" />
                    <h1 className='font-[500] text-[16px]'>{t("My Wallet")}</h1>
                  </div>
                  <h1 className='title text-[#0d4047]'>{currency}{isDriverSelected ? myWallet2 : myWallet}.00</h1>
                </div>
              </div>}

              <div style={{ margin: myWallet === 0 && "0" }} className="section-6">
                <div className="flex items-center justify-between border-b-[1px] pb-[10px] border-[#8080803b]">
                  <div className="flex items-center gap-[5px]">
                    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 24 24" fill="#0d4047" stroke="none" ><path d="M12.01 2.011c.852 0 1.668 .34 2.267 .942l.698 .698a1.2 1.2 0 0 0 .845 .349h1a3.2 3.2 0 0 1 3.2 3.2v1c0 .316 .126 .62 .347 .843l.698 .698a3.2 3.2 0 0 1 .002 4.536l-.698 .698a1.2 1.2 0 0 0 -.349 .845v1a3.2 3.2 0 0 1 -3.2 3.2h-1a1.2 1.2 0 0 0 -.843 .347l-.698 .698a3.2 3.2 0 0 1 -4.536 .002l-.698 -.698a1.2 1.2 0 0 0 -.845 -.349h-1a3.2 3.2 0 0 1 -3.2 -3.2v-1a1.2 1.2 0 0 0 -.347 -.843l-.698 -.698a3.2 3.2 0 0 1 -.002 -4.536l.698 -.698a1.2 1.2 0 0 0 .349 -.845v-1l.005 -.182a3.2 3.2 0 0 1 3.195 -3.018h1a1.2 1.2 0 0 0 .843 -.347l.698 -.698a3.2 3.2 0 0 1 2.269 -.944m2.49 10.989a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3m1.207 -4.707a1 1 0 0 0 -1.414 0l-6 6a1 1 0 0 0 1.414 1.414l6 -6a1 1 0 0 0 0 -1.414m-6.207 -.293a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3"></path></svg>
                    <div className="">
                      <h1 className='title text-[#0d4047]'>{t("Apply Coupon")}</h1>
                      {couponCode && <span className='text-[16px]'>{t("Use Code")} : <span className='font-[500]'>{couponCode.code}</span></span>}
                    </div>
                  </div>
                  <button onClick={HandleCoupanRemove} className={`font-[500] ${couponCode ? "text-red-500" : "text-[#0d4047]"} text-[18px]`}>{couponCode ? t("Remove") : t("Apply")}</button>
                </div>
                <div onClick={() => !couponCode && setIsCouponShow(true)} className="flex items-center justify-between py-[10px] cursor-pointer">
                  <h1 className=' text-gray-400 text-[16px]'>{t("View All Coupons")}</h1>
                  <LuChevronRight className='text-gray-400 text-[20px]' />
                </div>
              </div>

              <div className="section-2">
                <div className="flex items-center justify-between">
                  <div className="">
                    <h1 className='font-[500] text-[18px]'>{selectAddress ? selectAddress.address : t("Select Delivery Address")}</h1>
                    <p>{t("We deliver the product to this address.")}</p>
                  </div>
                  <button onClick={() => setIsLocationShow(true)} className="flex items-center gap-[5px] border-[1px] border-[#8080803b] px-[10px] py-[6px] rounded-[8px]">
                    <FiMapPin className='text-[20px] text-[#0d4047]' />
                    <IoChevronDown className='text-[20px] text-[#0d4047]' />
                  </button>
                </div>
              </div>

              <div className="section-7">
                <h1 className='title'>{t("Review Your Requirements for This Request")}</h1>
                <div className="data">
                  <h1 className='text-gray-700 text-[16px]'>{t("Shop Total")}</h1>
                  <h1 className='font-[500] text-[16px]'>{shopTotal}.00{currency}</h1>
                </div>

                {isDriverSelected && <div className="data">
                  <h1 className='text-gray-700 text-[16px]'>{t("Wallet")}</h1>
                  <h1 className='font-[500] text-[16px]'>-{wallet}.00{currency}</h1>
                </div>}

                {couponCode && <div className="data">
                  <h1 className='text-gray-700 text-[16px]'>{t("Coupon")}</h1>
                  <h1 className='font-[500] text-[16px]'>-{couponCode.amt}{currency}</h1>
                </div>}

                <div className="data">
                  <h1 className='text-gray-700 text-[16px]'>{t("Commission Rate")} ({comRate?.type})</h1>
                  <h1 className='font-[500] text-[16px]'>+{comRate?.rate}.0{currency}</h1>
                </div>

                <div className="flex items-center justify-between mt-[5px]">
                  <h1 className='text-[16px] font-[500]'>{t("Total Payable Amount")}</h1>
                  <h1 className='font-[500] text-[16px]'>{totalAmount}.0{currency}</h1>
                </div>
              </div>

            </div>

            <div className="btn-box flex items-center justify-between">
              <div className="">
                <h1 className='text-[18px] text-gray-500'>{t("Total Price")}</h1>
                <h1 className='font-[500] text-[17px]'>{currency}{totalAmount}.0</h1>
              </div>
              <button onClick={HandleContinuePayment} className='bg-[#0d4047] text-white font-[500] text-[16px] min-w-[250px] py-[8px] rounded-[50px]'>{t("Continue Total Payable Amount")}</button>
            </div>
          </div>

        </div>}

      {isShow && <div onClick={() => setIsShow("")} className="flex bg-[#00000069] h-full justify-center w-full fixed items-end left-0 top-0 z-[999]">
        <div style={{ borderRadius: "10px 10px 0 0" }} onClick={(e) => e.stopPropagation()} className="bottme-box max-h-[650px] scroll-container">
          <h1 className='font-[500] text-[20px] mb-[5px]'>{isShow.name}</h1>
          {details.map((item, index) => {
            return <DetailsList item={item} index={index} ImgBaseUrl={ImgBaseUrl} isShow={isShow} currency={currency} detaillod={detaillod} setDetailLod={setDetailLod} Userid={Userid} Docid={Docid} productId={productId} details={details} ApiBaseUrl={ApiBaseUrl} HandleFetchData={HandleFetchData} setDetails={setDetails} setIsShow={setIsShow} />
          })}
          <button onClick={() => setIsShow("")} className='payment-btn mt-[10px]'>{t("Done")}</button>
        </div>
      </div>}

      {isCouponShow && <div onClick={() => setIsCouponShow(false)} className='flex bg-[#00000069] h-full justify-center w-full fixed items-center left-0 top-0 z-[999]'>
        <div onClick={(e) => e.stopPropagation()} className="add-patient max-h-[700px] scroll-container" style={{ borderRadius: "10px" }}>
          <h1 className='font-[500] text-[18px] mb-[5px]'>{t("Best Coupon")}</h1>
          {couponList.map((item, index) => {
            return <div key={index} className="border-[1px] rounded-[10px] p-[10px] border-[#8080803b] mb-[5px] flex items-center justify-between">
              <div className="">
                <div className="leading-[20px]">
                  <h1 className='font-[500] text-[20px]'>{item.title}</h1>
                  <p className='text-gray-500'>{item.sub_title}</p>
                </div>
                <div className="mt-[10px]">
                  <h1>{t("Coupon Code")}: <span className='text-[#0d4047] font-[500]'>{item.code}</span></h1>
                  <h1>{t("Coupon Amount")}: <span className='font-[500]'>{currency}{item.discount_amount}</span></h1>
                  <h1>{t("Minimum Amount")}: <span className='font-[500]'>{currency}{item.min_amount}</span></h1>
                  <h1>{t("Ex Date")}: <span className='font-[500]'>{item.end_date}</span></h1>
                </div>

                <button disabled={totalAmount < item.min_amount && true} onClick={() => HandleCoupanAdd(item.code, item.discount_amount, item.id)} className={` ${totalAmount > item.min_amount ? "coupon-btnAct" : "coupon-btnDic"}`} >{t("Apply Coupons")}</button>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="#ff8000" stroke="none" ><path d="M12.01 2.011c.852 0 1.668 .34 2.267 .942l.698 .698a1.2 1.2 0 0 0 .845 .349h1a3.2 3.2 0 0 1 3.2 3.2v1c0 .316 .126 .62 .347 .843l.698 .698a3.2 3.2 0 0 1 .002 4.536l-.698 .698a1.2 1.2 0 0 0 -.349 .845v1a3.2 3.2 0 0 1 -3.2 3.2h-1a1.2 1.2 0 0 0 -.843 .347l-.698 .698a3.2 3.2 0 0 1 -4.536 .002l-.698 -.698a1.2 1.2 0 0 0 -.845 -.349h-1a3.2 3.2 0 0 1 -3.2 -3.2v-1a1.2 1.2 0 0 0 -.347 -.843l-.698 -.698a3.2 3.2 0 0 1 -.002 -4.536l.698 -.698a1.2 1.2 0 0 0 .349 -.845v-1l.005 -.182a3.2 3.2 0 0 1 3.195 -3.018h1a1.2 1.2 0 0 0 .843 -.347l.698 -.698a3.2 3.2 0 0 1 2.269 -.944m2.49 10.989a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3m1.207 -4.707a1 1 0 0 0 -1.414 0l-6 6a1 1 0 0 0 1.414 1.414l6 -6a1 1 0 0 0 0 -1.414m-6.207 -.293a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3"></path></svg>
            </div>
          })}
        </div>
      </div>}

      {isLocationShow && <div onClick={() => setIsLocationShow("")} className="flex bg-[#00000069] h-full justify-center w-full fixed items-end left-0 top-0 z-[999]">
        <div onClick={(e) => e.stopPropagation()} className="bg-white p-[10px] rounded-t-[10px] min-w-[20%]">
          <h1 className='font-[500] text-[18px]'>{t("Choose a Delivery Address")}</h1>
          <button onClick={() => { setIsLocationShow2(true); setIsLocationShow("") }} className="flex items-center gap-[10px] mb-[10px]">
            <FiPlus className='text-[30px] text-[#0d4047] border-[1px] border-[#0d4047] rounded-[5px] py-[5px] min-w-[40px]' />
            <h1 className='font-[500] text-[18px] text-[#0d4047]'>{t("Add New Address")}</h1>
          </button>
          <div className="max-h-[400px] scroll-container">
            {addressList.length >= 1
              ? addressList.map((ietm, index) => {
                return <div onClick={() => { setSelectAddress({ address: ietm.address, id: ietm.id }); setIsLocationShow("") }} key={index} className="border-[1px] border-[#8080803b] rounded-[10px] py-[5px] px-[10px] mt-[5px] cursor-pointer">
                  <h1 className='font-[500] text-[18px]'>{ietm.address_as} {t("Address")}</h1>
                  <div className="flex items-center gap-[5px]">
                    <IoCallOutline className='text-green-500 text-[22px]' />
                    <h1 className='font-[500] text-[16px] text-gray-500'>{ietm.country_code} {ietm.phone}</h1>
                  </div>
                  <div className="flex items-center gap-[5px]">
                    <TiLocation className='text-[#0d4047] text-[22px]' />
                    <h1 className='font-[500] text-[16px]'>{ietm.address}</h1>
                  </div>
                </div>
              })
              : <div className="h-[300px] flex items-center justify-center">
                <h1 className='font-[500] text-[18px]'>{t("Add New Address")}</h1>
              </div>
            }
          </div>
        </div>
      </div>}

      {isLocationShow2 && <div onClick={() => setIsLocationShow2("")} className="flex bg-[#00000069] h-full justify-center w-full fixed items-end left-0 top-0 z-[999]">
        <div onClick={(e) => e.stopPropagation()} className="bottme-box google-map">
          {isLoaded && <GoogleMap
            center={{ lat: latitude, lng: longitude }}
            zoom={15}
            onClick={handleMapClick}
          >
            <Marker position={{ lat: latitude, lng: longitude }} />
          </GoogleMap>}

          <div className="mt-[10px]">
            <div className="h-[120px]">
              <textarea onChange={(e) => setAddressData({ ...addressData, address: e.target.value })} name="" className='min-h-[100%] max-h-[100%] w-[100%] border-[2px] border-[#8080803b] outline-none rounded-[10px] p-[10px] focus-within:border-[#0d4047]' placeholder='Complete address' id=""></textarea>
            </div>
            <div className="mt-[5px]">
              <input onChange={(e) => setAddressData({ ...addressData, houseno: e.target.value })} className='w-[100%] border-[2px] border-[#8080803b] outline-none rounded-[10px] p-[10px] focus-within:border-[#0d4047]' type="text" placeholder='House no' />
            </div>
            <div className="mt-[5px]">
              <div className="border-[2px] border-[#8080803b] focus-within:border-[#534cfe] rounded-[10px] p-[10px]">
                <PhoneInput
                  className="w-[100%]"
                  international
                  defaultCountry="IN"
                  value={value}
                  onChange={setValue}
                  name="phone"
                />
              </div>
            </div>
            <div className="mt-[5px]">
              <input onChange={(e) => setAddressData({ ...addressData, landmark: e.target.value })} className='w-[100%] border-[2px] border-[#8080803b] outline-none rounded-[10px] p-[10px] focus-within:border-[#0d4047]' type="text" placeholder='Landmark' />
            </div>
            <div className="h-[120px] mt-[5px]">
              <textarea onChange={(e) => setAddressData({ ...addressData, instruction: e.target.value })} className='min-h-[100%] max-h-[100%] w-[100%] border-[2px] border-[#8080803b] outline-none rounded-[10px] p-[10px] focus-within:border-[#0d4047]' placeholder='How to rech instructions (Optional)' id=""></textarea>
            </div>
            <div className="mt-[10px]">
              <h1 className='font-[500] text-[18px] mb-[5px]'>{t("Save Address As")}</h1>
              <input onChange={(e) => setAddressData({ ...addressData, address_as: e.target.value })} className='w-[100%] border-[2px] border-[#8080803b] outline-none rounded-[10px] p-[10px] focus-within:border-[#0d4047]' type="text" placeholder='Eg: Home, Store' />
            </div>
          </div>
          <button onClick={HandleSaveAddress} className='payment-btn mt-[10px]'>{t("Save Address")}</button>
        </div>
      </div>}

      {isPayment && <div onClick={() => setIsPayment(false)} className="flex bg-[#00000069] h-full justify-center w-full fixed items-end left-0 top-0 z-[999]">
        <div onClick={(e) => e.stopPropagation()} className="bottme-box">
          <h1 className='font-[500] text-[20px]'>{t("Select Payment Method")}</h1>
          <Payment Amount={totalAmount} INDEX={16} Data={allData} photos={photos} did={Docid} />
        </div>
      </div>}

    </div>
  )
}

export default Checkout
/* jshint ignore:end */